//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../no/Section.js";
let d=[[[0,"ParameterLength",1,0],[0,"ParameterPercent",1,0]],[[[],"GetLawValueAtPoint",{R_:{lawValueAtPoint:"Expression"}},0,0],[["val_string"],"SetLawValueAtPoint",{},1,0],[[],"GetParentSpine",{R_:{parentSpine:"Section"}},0,0],[["parent"],"SetParentSpine",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.SpinePointData = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.SpinePointData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.SpinePointData.ParameterType = Object.freeze({
    "Normal" : "Normal", "Percent" : "Percent", "Length" : "Length"});

export default SPLM;